import Vue from 'vue'

export default Vue.component('ajax-loader', {
    props: ['hide', 'inline'],
    template: '<div v-if="!hide" class="width-full text-center"><div class="lds-ellipsis lds-ellipsis-large"><div></div><div></div><div></div><div></div></div></div>'
});